import { RouterProvider, createBrowserRouter, useParams } from "react-router-dom";
import "./App.scss";
import { externalAppType } from "./common/consts/externalAppType";
import { pageStates } from "./common/consts/pageStates";
import InfoPage from "./components/info/info";
import NoOffer from "./components/no-offer/no-offer";
import PloomRegisterCustomer from "./components/ploom-register-customer/ploom-register-customer";
import PloomRegisterForm from "./components/ploom-register-form/ploom-register-form";
import PointsOfSale from "./components/points-of-sale/points-of-sale";
import RegistrationSuccess from "./components/registration-success/registration-success";
import TradeInRegisterAura from "./components/trade-in/routes/trade-in-register-aura/trade-in-register-aura"
import TradeInRegister from "./components/trade-in/routes/trade-in-register/trade-in-register";

const allowedSourceAppTypes = Object.values(externalAppType);

function SourceAppTypeGuard({ children }) {
  const { sourceAppType } = useParams();

  if (!allowedSourceAppTypes.includes(sourceAppType)) {
    return <InfoPage pageState={pageStates.wrongRegistrationUrl} />;
  }

  return children;
}

function App() {
  const router = createBrowserRouter([
    {
      path: "/konsument/:offerId",
      element: <PloomRegisterForm />,
    },
    {
      path: "/:sourceAppType/:externalId",
      element: <SourceAppTypeGuard><PloomRegisterForm /></SourceAppTypeGuard>,
    },
    {
      path: "/konsument/trade-in/:offerId",
      element: <TradeInRegister />,
    },
    {
      path: "/:sourceAppType/trade-in/:externalId",
      element: <SourceAppTypeGuard><TradeInRegister /></SourceAppTypeGuard>,
    },
    {
      path: "/konsument/tin/:transactionId",
      element: <TradeInRegisterAura />,
    },
    {
      path: "/:sourceAppType/tin/:transactionId",
      element: <SourceAppTypeGuard><TradeInRegisterAura /></SourceAppTypeGuard>,
    },
    
    {
      path: "/success",
      element: <RegistrationSuccess />,
    },
    {
      path: "/no-offer",
      element: <NoOffer />,
    },
    {
      path: "/lokalizacje",
      element: <PointsOfSale mapSiteConfigKey="default" />,
    },
    {
      path: "/lokalizacjezabka",
      element: <PointsOfSale  mapSiteConfigKey="zabka" />,
    },
    {
      path: "/lokalizacjelagardere",
      element: <PointsOfSale  mapSiteConfigKey="lagardere" />,
    },
    {
      path: "/konsument/tranzakcja/:transactionId",
      element: <PloomRegisterCustomer />,
    },
    {
      path: "/konsument/t/:transactionId",
      element: <PloomRegisterCustomer />,
    },
    {
      path: "/error",
      element: <InfoPage pageState={pageStates.unknownError} />,
    },
    {
      path: "/device-registration-failure",
      element: <InfoPage pageState={pageStates.deviceRegistrationFailure} />,
    },
    {
      path: "/transaction-cancelled",
      element: <InfoPage pageState={pageStates.transactionCancelled} />,
    },
    {
      path: "/expired",
      element: <InfoPage pageState={pageStates.transactionExpired} />,
    },
    {
      path: "*",
      element: <InfoPage pageState={pageStates.wrongRegistrationUrl} />,
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
